import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_167: DocMigration = {
  maxSchemaVersion: "0.0.167",
  description: "Roof eave return frieze board flag",
  apply(json: any) {
    const { roofs } = json;

    // roof instances
    for (const roofId in roofs) {
      const roof = roofs[roofId];
      const { roofSettings = {} } = roof;
      roofSettings.eaveFriezeBoardExtents = "EAVE";

      roofs[roofId] = {
        ...roof,
        roofSettings,
      };
    }

    return json;
  },
};

export default migration_0_0_167;
